import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

const Education = ({ bg, color }) => (
    <Box id="education" p={5} bg={bg} borderRadius="lg" boxShadow="md">
        <Heading as="h2" size="lg" color={color}>Education</Heading>
        <VStack align="start" mt={4}>
            <Text color={color}>Bachelor of Technology in Computer Science, NIT Hamirpur</Text>
            <Text color={color}>2021 - Present</Text>
        </VStack>
    </Box>
);

export default Education;
